<template>
  <v-dialog v-model="showDialog" width="500" eager persistent>
    <v-card>
      <v-card-actions class="justify-end">
        <div class="text-right">
          <v-btn fab text small @click="$emit('closeDialog')" right
            ><v-icon>close</v-icon></v-btn
          >
        </div>
      </v-card-actions>

      <div class="text-center">
        <v-avatar color="#FDE1D6" size="70">
          <v-icon dark color="primary" large> mdi-check </v-icon>
        </v-avatar>
      </div>

      <v-card-title class="justify-center">
        EventConnect link created
      </v-card-title>
      <v-card-text>
        <p>
          Thanks for choosing EventConnect to help your event attendees connect
          easily!
        </p>
        <p v-if="currentEvent.hasSubEvents">
          Once you have closed this pop-up, you will see the Event Program tab
          where you can start adding your sub-events.
        </p>
        <p v-else>
          <!-- This is the link you created, which you can include in your event
          invitation, email and/or any of your preferred communication channels. -->
          Once you have closed this pop-up, you will see a Link Invitation tab
          where you can invite people to join this link.
        </p>

        <!-- <p v-if="currentEvent.linkPrivacy == 'Private'">
          Your attendees will receive your Multi Connect link shortly via email and we will remind them again at the
          time of link activation and then before it expires so they don’t forget to start connecting.
        </p> -->
        <template>
          <!-- <p>
            Share this link to your event calendar or meeting invitation. You can find this link in the Event Details
            tab. This link will activate on {{ formattedDateTime(currentEvent.getEventActivationDateTime()) }} and
            expiring on
            {{ formattedDateTime(currentEvent.getEventExpirationDateTime()) }}
          </p> 
          <div class="d-flex align-center justify-space-between">
            <v-row align="center">
              <v-col cols="12">
                <v-sheet
                  class="mb-0 px-2 d-flex justify-space-between grey lighten-4 align-center py-2"
                  outlined
                  rounded="lg"
                >
                  <p class="mb-0">
                    {{ currentEvent.dynamicLink.split("https://")[1] }}
                  </p>

                  <v-btn icon @click="copyToClipboard">
                    <v-icon fab>mdi-content-copy</v-icon>
                  </v-btn>
                </v-sheet>
              </v-col>
            <v-col cols="5">
                <v-btn
                  color="primary"
                  depressed
                  class="text-body-1"
                  @click="copyToClipboard"
                  >Copy link and close</v-btn
                >
              </v-col>
            </v-row> 
          </div> -->
        </template>

        <v-btn
          color="primary"
          depressed
          block
          :text="currentEvent.linkPrivacy == 'Public' ? true : false"
          class="text-body-1 mt-4"
          @click="$emit('closeDialog')"
          >Continue</v-btn
        >
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Utility from "@/shared/utility";

export default {
  props: {
    showDialog: { type: Boolean, default: true },
    linkType: { type: String },
    link: { type: String },
  },
  computed: {
    ...mapGetters(["currentEvent"]),
  },
  data() {
    return {
      items: [
        { id: "1", text: "Multi Connect" },
        { id: "2", text: "Business Card Prize Draws" },
        { id: "3", text: "Promotion for all your events" },
      ],
    };
  },
  methods: {
    ...mapActions(["showSnackbar"]),
    eventLink() {
      const link = this.$appHostUrl + '/event/' + this.currentEvent.id + `?name=${this.currentEvent.name}`;
      return link;
    },
    async copyToClipboard() {
      Utility.copyToClipboard(encodeURI(this.eventLink()));
      this.showSnackbar({ show: true, text: "Copied Successfully!" });
      this.$emit("closeDialog");
    },
    formattedDateTime(dateTime) {
      return Utility.formatDateTime(dateTime);
    },
  },
};
</script>

<style></style>